/** Step-to-step conversion rate as a display percent (0–100), or null when prior step is zero. */
export function conversionRatePercent(from: number, to: number): number | null {
  if (from <= 0) return null;
  return Math.round((to / from) * 1000) / 10;
}

export function formatConversionRate(from: number, to: number): string {
  const rate = conversionRatePercent(from, to);
  if (rate === null) return '—';
  return `${rate}%`;
}
